import { Themes } from '../core/models/themes';
import { Component, OnInit } from '@angular/core';
import { Candidates } from '../core/models/candidates';
import { City } from '../core/models/city';
import { CandidatesService } from '../core/services/candidates/candidates.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-dashboarddois',
  templateUrl: './dashboardum.component.html',
  styleUrls: ['./dashboardum.component.css']
})
export class DashboardumComponent implements OnInit {
  cities: City[] = [
    { key: 16, value: 'CACHOEIRO DE ITAPEMIRIM' },
    { key: 17, value: 'CARIACICA'},
    { key: 19, value: 'COLATINA' },
    { key: 29, value: 'GUARAPARI'},
    { key: 43, value: 'LINHARES'},
    { key: 70, value: 'SERRA'},
    { key: 77, value: 'VILA VELHA'},
    { key: 78, value: 'VITÓRIA'}
  ];
  cidadeSelecionada =  0; // Retorna o primeiro do select
  temas: Themes[] = [
    { key: 1, value: 'ECONOMIA E EMPREGO' },
    { key: 2, value: 'EDUCAÇÃO'},
    { key: 3, value: 'POLÍTICA E CORRUPÇÃO' },
    { key: 4, value: 'POLÍTICAS SOCIAIS E DIREITOS HUMANOS'},
    { key: 5, value: 'SAÚDE'},
    { key: 6, value: 'SEGURANÇA'}

  ];
  //Variavel que chaveia para modelo normal e modelo de comparador
  modeloTemplateCheckbox = false;//comparador = True e nao comparador = false

  HiddenModeloNormal = false;
  HiddenModeloCompare = true;
  temaSelecionado =  0; //
  //Variavel de controle do comparador
  idCandidatoSelecionado1 = 0;
  idCandidatoSelecionado2 = 0;
  indexCandidatoSelecionado1 = 0;
  indexCandidatoSelecionado2 = 0;

  //variavel desativar campo candidatos
  disabledCandidato1 = true;
  disabledCandidato2 = true;

  cardAnterior = null;
  candidates: Candidates[] = [];
  currentPage = 1;
  qtdExibicao = 100;
  //Campos para desativar os botoes
  btnNotSaude = true;
  btnNotEducacao = true;
  btnNotEconomia = true;
  btnNotSeguranca = true;
  btnNotPolitica = true;
  btnNotSocial = true;
  isActive = false;

  constructor(
    private candidateService: CandidatesService
  ) { }

  ngOnInit(): void {
  }

  getCandidatesByID(cityId: number): void {
    this.cidadeSelecionada = cityId;
    this.isActive = true;
    this.candidateService
      .get(
        this.cidadeSelecionada,
        this.currentPage,
        this.qtdExibicao)
      .subscribe(candidates => {
        this.candidates = (candidates != null) ? candidates : [];
        this.isActive = false;
        //Retorna para o valor default quando pega novos candidatos
        this.idCandidatoSelecionado1 = 0;
        this.idCandidatoSelecionado2 = 0;
        this.indexCandidatoSelecionado1 = 0;
        this.indexCandidatoSelecionado2 = 0;
        this.disabledCandidato1 = false;
        this.disabledCandidato2 = false;
        //console.log(this.candidates);
      }, (err: HttpErrorResponse) => {
        this.isActive = false;
      });
  }

  onSelectCidade(key: number): void {
    this.btnNotSaude = false;
    this.btnNotEducacao = false;
    this.btnNotEconomia = false;
    this.btnNotSeguranca = false;
    this.btnNotPolitica = false;
    this.btnNotSocial = false;
    this.cidadeSelecionada = key;
    //console.log(key);
    this.getCandidatesByID(this.cidadeSelecionada);
    this.onClickBtn('SAÚDE');
  }

  onClickBtn(tema: string): void {
    const temaAux = this.temas.find(x => x.value == tema);
    this.temaSelecionado = temaAux.key;
    //console.log(tema);
    //console.log(this.modeloTemplateCheckbox);
    for(var _i=0; _i< this.temas.length; _i++){
      //console.log(this.temas[_i].value);
      if(tema == this.temas[_i].value){
        if(!this.modeloTemplateCheckbox){
          let element = document.getElementById(this.temas[_i].value+'Tema');
          element.className = '';
        }
        let elementTema = document.getElementById(this.temas[_i].key.toString());
        elementTema.className = 'ativo btn btn-options btn-primary ';
      }
      else{
        if(!this.modeloTemplateCheckbox){
          let element = document.getElementById(this.temas[_i].value+'Tema');
          element.className = 'inativo';
        }
        let elementTema = document.getElementById(this.temas[_i].key.toString());
        elementTema.className = 'btn btn-options btn-primary ';
      }
    }
  }
  onClickBtnCard(idCard: string): void{
    //console.log(idCard);
    //console.log(this.cardAnterior );
    if(this.cardAnterior != null){
      let element = document.getElementById('heading'+this.cardAnterior);
      if(element != null){
        element.className = 'card-header';
        let elementIcon = document.getElementById('icon-accordion'+this.cardAnterior);
        //console.log(elementIcon);
        elementIcon.className = 'icon-accordion-open';
      }
    }
    if(this.cardAnterior == idCard){
      let element = document.getElementById('heading'+this.cardAnterior);
      element.className = 'card-header';
      let elementIcon = document.getElementById('icon-accordion'+this.cardAnterior);
      //console.log(elementIcon);
      elementIcon.className = 'icon-accordion-open';
      this.cardAnterior = null;
    }
    else{
      let element = document.getElementById('heading'+idCard);
      element.className = 'card-header card-ativo';
      let elementIcon = document.getElementById('icon-accordion'+idCard);
      //console.log(elementIcon);
      elementIcon.className = 'icon-accordion-close';

      this.cardAnterior = idCard;
    }

  }

  changeTemplateContent($event): void{
    this.modeloTemplateCheckbox = $event.target.checked;
    if(this.modeloTemplateCheckbox){
      this.HiddenModeloNormal = true;
      this.HiddenModeloCompare = false;
    }
    else{
      this.HiddenModeloNormal = false;
      this.HiddenModeloCompare = true;
      const temaAux = this.temas.find(x => x.key == this.temaSelecionado);
      this.onClickBtn(temaAux.value);
    }


  }

  onSelectCandidato(chave: number, selecao: number): void{
    if (selecao === 1){
      const index = this.candidates.findIndex(x => x.id == chave);
      this.idCandidatoSelecionado1 = chave;
      this.indexCandidatoSelecionado1 = index;
    }
    else{
      const index = this.candidates.findIndex(x => x.id == chave);
      this.idCandidatoSelecionado2 = chave;
      this.indexCandidatoSelecionado2 = index;
    }
  }


}
